import React, { Fragment } from 'react';
import { Button, Col, ControlLabel, FormGroup, FormControl, Glyphicon } from 'react-bootstrap';
import { Field, FieldArray, ErrorMessage } from 'formik';

export const InputArray = ({ name, type, label, col, ...props }) => {
    const renderItems = (items, onRemoveClick) => {
        return (
            items.map((item, index) =>
                <Fragment key={index}>
                    <div className={index != 0 ? 'input-group' : undefined}>
                        <FormControl
                            componentClass={Field}
                            name={`${name}[${index}]`}
                            type={type != null ? type : 'text'}
                            {...props}
                        />
                        {renderRemoveButton(index, onRemoveClick)}
                    </div>
                    <ErrorMessage
                        component="div"
                        className="error text-danger"
                        name={`${name}[${index}]`}
                    />
                </Fragment>
            )
        )
    };

    const renderAddButton = (onClick) => {
        return (
            <Button
                bsSize="small"
                bsStyle="primary"
                onClick={() => onClick('')}
            >
                <Glyphicon glyph="plus" /> Add
            </Button>
        )
    };

    const renderRemoveButton = (index, onClick) => {
        if (index != 0) {
            return (
                <div className="input-group-btn">
                    <Button
                        bsStyle="danger"
                        onClick={() => onClick(index)}
                    >
                        <Glyphicon glyph="remove" />
                    </Button>
                </div>
            );
        }
    };

    return (
        <FieldArray name={name}>
            {({ push, remove, form: { values, touched, errors } }) =>
                <FormGroup
                    controlId={name}
                    validationState={touched[name] && errors[name] ? 'error' : null}
                >
                    <Col componentClass={ControlLabel} sm={label.col}>
                        {label.text}
                    </Col>
                    <Col className="repeater" sm={col}>
                        {renderItems(values[name], remove)}
                        {renderAddButton(push)}
                    </Col>
                </FormGroup>
            }
        </FieldArray>
    );
};